// Repairs billing weeks read while the server diary reader was failing: the page was scanned
// instead, and a court heading such as "Wl SUNSHINE MAGISTRATES' COURT Location: Counsel briefed"
// became a row of its own, leaving the appearances under it with no court.

const COURT = /\b(?:court|justice centre)\b/i;

// A row whose "client" is really a heading. Real clients are "SURNAME, First".
export function isDiaryHeadingRow(entry = {}) {
  const client = String(entry.client_name || "");
  return /\bLocation:/i.test(client) && COURT.test(client) && !client.includes(",") && !entry.lawyer_initials;
}

function courtFromHeading(client = "") {
  return client
    .replace(/\bLocation:.*$/i, "")
    .replace(/^\S{1,2}\s+/, "") // the misread calendar icon
    .replace(/[’®]/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}

// The entries without their heading rows; appearances after a heading that have no court get
// its court. `keep(entry)` protects a heading row someone has written on. Returns the same
// array when there is nothing to do.
export function repairDiaryHeadingRows(entries = [], keep = () => false) {
  if (!entries.some((entry) => isDiaryHeadingRow(entry) && !keep(entry))) return entries;
  const repaired = [];
  let heading = null;
  for (const entry of entries) {
    if (isDiaryHeadingRow(entry) && !keep(entry)) {
      heading = { date: entry.date, court: courtFromHeading(entry.client_name) };
      continue;
    }
    if (heading && (entry.date !== heading.date || entry.court)) heading = null;
    repaired.push(heading ? { ...entry, court: heading.court } : entry);
  }
  return repaired;
}
